import { isValidRepub } from './repub-util';
import { getRepubPath } from './repubs';

/**
 * Extracts the path from a URL, excluding the repub segment
 * @param repub - The repub code (e.g., 'US', 'DE', 'OC')
 * @param requestUrl - The full request URL
 * @returns The path excluding repub (e.g., 'casino/real-money-casinos')
 */
export function getPathExcludingRepubFromUrl(repub: string | undefined, requestUrl: string): string {
  // Handle undefined repub - throw error
  if (!repub) {
    throw new Error('repub is undefined');
  }

  // Validate repub is a valid repub code
  if (!isValidRepub(repub)) {
    throw new Error('repub not valid');
  }

  // Get the repub path with leading slash format (e.g., '/us', '/de', or '' for root)
  const repubPath = getRepubPath(repub);

  // Parse the URL to get the pathname, search, and hash
  const url = new URL(requestUrl);
  let pathname = url.pathname;

  // If repub has a path (not root), remove it from the pathname
  if (repubPath) {
    // Remove the repub path and any leading slash
    if (pathname.startsWith(repubPath)) {
      pathname = pathname.slice(repubPath.length);
    }
  }

  // Remove leading slash if present
  const pathWithoutSlash = pathname.startsWith('/') ? pathname.slice(1) : pathname;

  // Include search and hash if present
  return pathWithoutSlash + url.search + url.hash;
}
